import { assertIsNotUndefined } from "common/utils/assertOfType";
import { getWindowPersistentValue } from "common/utils/persistentValue";
import type { RenderParamsServices } from "./defaultRenderParamsForGPUTier";
import type { SSFXImageRenderer } from "./threejs/higharc/SSFXImageRenderer";

interface ActiveSharedWebGLServices {
  readonly services: RenderParamsServices & {
    readonly imageRenderer: SSFXImageRenderer;
  };
}

export function getActiveSharedWebGLServices(): ActiveSharedWebGLServices["services"] {
  // activeSharedWebGL stores a SharedWebGL instance. Keep this structural type
  // narrow to avoid a type import cycle through SharedWebGL -> THREEViewerServices.
  const activeSharedWebGL = getWindowPersistentValue<ActiveSharedWebGLServices | undefined>(
    "activeSharedWebGL",
    undefined,
  );
  assertIsNotUndefined(activeSharedWebGL);
  return activeSharedWebGL.services;
}
